

if (!customElements.get('collections-slider') ) {
  class CollectionsSlider extends HTMLElement {
    constructor() {
      super();

      this.state = {
        slider: null
      };

      this.elements = {
        swiper: this.querySelector('.swiper'),
        swiperBtnNext: this.querySelector('.slider-button-next'),
        swiperBtnPrev: this.querySelector('.slider-button-prev')
      };
    }
  
    connectedCallback() {
      this.initSwiper();
    }
  
    disconnectedCallback() {
      this.state.slider.destroy();
    }

    initSwiper() {
      this.state.slider = new Swiper(this.elements.swiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: this.elements.swiperBtnNext,
          prevEl: this.elements.swiperBtnPrev,
        }
      });
    }
  
  }
  customElements.define('collections-slider', CollectionsSlider);
}